import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { SessionService } from '../../../services/session.service';
import { AuthenticationType } from '../../../services/oidc.factory';
import { PlatformApiService, ResultFilter } from '../../../services/platform-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IntegrationPartner } from 'src/app/models/ManageIntegrationModel';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';
import { Account } from '../../../models/AccountModel';
import { Assessment } from 'src/app/models/AssessmentModel';
import { MatDialog } from '@angular/material/dialog';
import { AssessmentTypeListComponent } from 'src/app/secured/assessment/assessment-type-list.component';

@Component({
  selector: 'cw-ci-connectwise-layout',
  templateUrl: './connectwise-layout.component.html',
  styleUrls: ['./connectwise-layout.component.scss']
})
export class ConnectWiseLayoutComponent implements OnInit {
  state = 'LOADING';
  requestedState:string;
  requestedCompanyId:number;
  requestedAccount:Account;
  partnerKey:string;
  partner:IntegrationPartner;
  loadingAccount = false;
  unavailableReason:string = undefined;
  dialogMessage:string = undefined;
  dialogTitle:string = undefined;
  dialogRef:any;

  constructor(public _router: Router, public _sessionService: SessionService, public themeManager: ThemeManagerService, private _platformApi: PlatformApiService, private _changeDetector: ChangeDetectorRef, private _activatedRoute: ActivatedRoute, public dialog: MatDialog) {
  }

  ngOnInit() {
    console.log('ConnectWiseLayoutComponentng:ngOnInit:route', this._activatedRoute);

    this.partnerKey = this._activatedRoute.snapshot.data.partnerKey;

    if (this.partnerKey != 'connectwise') {
      this.requestedState = 'INVALID_PARTNER';
    } else {
      this._activatedRoute.queryParams.subscribe(params => {
        console.log('ConnectWiseLayoutComponentng:ngOnInit:params', params);

        if (Object.keys(params).includes('clientAssessments')) {
          this.requestedState='CLIENTASSESSMENTS';
        } else if (Object.keys(params).includes('myAssessments')) {
          this.requestedState='COMPANYASSESSMENTS'
        } else if (Object.keys(params).includes('mspDashboard')) {
          this.requestedState='MSPDASHBOARD'
        } else if (Object.keys(params).includes('clientComparisons')) {
          this.requestedState='CLIENTCOMPARISONS'
        } else {
          this.requestedState='ROUTING';
        }

        console.log('ConnectWiseLayoutComponentng:ngOnInit:requestedState', this.requestedState)
      });
    };
  }

  onConnectWiseEvent(event) {
    if (event.response == 'getmemberauthentication') {
      this._sessionService.setAuthenticationType(AuthenticationType.CONNECTWISE, event.data);
      this._platformApi.getCredentials().subscribe(creds => {
        this._sessionService.setApiCredentials(creds);
        this.updateState();
      }, err => {
        console.log('Error getting creds', err);
        if(err.status==401) {
          this.dialogTitle = 'UNAUTHORIZED';
          this.dialogMessage = 'You are not authorized to access this application. Please contact an administrator for access.';
          this.requestedState='ERRORSTATE';
          this.state = this.requestedState;
        } else {
          this.dialogTitle = 'ERROR';
          this.dialogMessage = 'An error has occurred. Please contact an administrator.';
          this.requestedState='ERRORSTATE';
          this.state = this.requestedState;
        }
      });
    } else if (event.event == 'onLoad') {
      this.themeManager.setThemeClass('connectwise-theme');

      if (event.data.screenObject && +event.data.screenObject.id > 0) {
        this.requestedCompanyId = +event.data.screenObject.id;
      }
      this.updateState();
    }

    this._changeDetector.detectChanges();
  }

  updateState() {
    if (this._sessionService.getCurrentAccount()) {
      if (this._sessionService.isExpiredTrial() ||
          (this._sessionService.getInstanceStatus() != 'active' || this._sessionService.getPaymentStatus() == 'cancelled') ||
          (this._sessionService.getPaymentStatus() == 'missing')) {
        this.requestedState='ACCOUNTUNAVAILABLE';
        this.state = this.requestedState;
      } else if (this.requestedState == 'CLIENTASSESSMENTS' && this.requestedCompanyId && this.requestedCompanyId > 0) {
        if (!this.loadingAccount) {
          this.loadingAccount = true;
          if (this._sessionService)
          this._platformApi.getManageSubAccount(this._sessionService.getWorkingCredential().account.id, this.requestedCompanyId).subscribe(acct => {
            this.requestedAccount = acct;
            this.loadingAccount = false;
            this.navigateAssessmentRoute(this.requestedAccount);                                                                                         
          }, err => {
            if (err.error.code == 'NUM_SUB_ACCOUNTS_EXCEEDED') {
              this.unavailableReason = 'FEATUREUNAVAILABLE';
              this.dialogMessage = 'You have reached the company limit for your trial.  You can continue to provide high-value risk assessments for your other customers by upgrading to a paid subscription.';

              this.requestedState = 'ACCOUNTUNAVAILABLE'
              this.state = this.requestedState;
            } else {
              this.dialogTitle = 'ERROR';
              this.dialogMessage = 'An error has occurred. Please contact an administrator.';
              this.requestedState='ERRORSTATE';
              this.state = this.requestedState;
            }
            this.loadingAccount = false;
          });
        }
      } else if (this.requestedState == 'COMPANYASSESSMENTS') {
        if (!this.loadingAccount) {
          this.loadingAccount = true;
          this.state = 'ROUTING';
          console.log('ConnectWiseLayoutComponent:updateState:internalAssessmentRoute', `internal/assessments`);
          this._router.navigate([`internal/assessments`], {relativeTo: this._activatedRoute});
        }
      } else {
        this.state = this.requestedState;
      }
    } else {
      console.log('No current account');
    }
  }

  displayAssessmentDialog(requestedAccount) {
    this._platformApi.getAssessments(new ResultFilter(undefined, undefined, undefined,undefined, {planId: requestedAccount.planSubscription.planId, isInTrial: requestedAccount.isInTrial(), excludeTypeList: ['CERTIFICATION']}))
      .subscribe(assessmentTemplates => {
      if (assessmentTemplates.count > 1) {
        if (this.dialogRef != undefined) {
          return;
        } else {
          this.dialogRef = this.dialog.open(AssessmentTypeListComponent, {
            panelClass: 'flush-dialog',
            data: {planId: requestedAccount.planSubscription.planId, isInTrial: requestedAccount.isInTrial()},
            disableClose: true,
          });
          this.dialogRef.afterClosed().subscribe(selectedValue => {
            this.createAccountAssessment(requestedAccount, selectedValue.value);
          });
        }
      } else {
        this.createAccountAssessment(requestedAccount, assessmentTemplates.results[0].id);
      }
    });
  }

  createAccountAssessment(requestedAccount, selectedValue) {
    this._platformApi.createAccountAssessment(requestedAccount.id, selectedValue).subscribe(resp=>{
      this.navigateAssessmentRoute(requestedAccount)
    })
  }

  navigateAssessmentRoute(requestedAccount) {
    this._platformApi.getAccountAssessments(requestedAccount.parentId, requestedAccount.id).subscribe(results => {
      if (results.results.length > 0) {
        this.state = 'ROUTING';
        console.log('ConnectWiseLayoutComponent:updateState:companyAssessmentRoute', `companies/${requestedAccount.id}`, {relativeTo: this._activatedRoute});
        this._router.navigate([`companies/${requestedAccount.id}`], {relativeTo: this._activatedRoute});
      } else {       
        this.state = 'ASSESSMENTTYPES';            
        this.displayAssessmentDialog(requestedAccount);
      }
    });
  }
}